import { Observable } from "rxjs";

export function fromMediaQuery(query: string | MediaQueries) {
	return new Observable<boolean>(subscriber => {
		const matchQuery = matchMedia(query);
		const func = (ev: MediaQueryListEvent) => { subscriber.next(ev.matches) };
		matchQuery.addEventListener('change', func);
		subscriber.next(matchQuery.matches);
		
		subscriber.add(() => matchQuery.removeEventListener('change', func));
	});
}

export enum MediaQueries {
	NARROW_SCREEN = '(max-width: 768px)',
	HOVER_SUPPORTED = '(hover: hover) and (pointer: fine)'
}